import {
    ChangeDetectorRef,
    Directive,
    Inject,
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
    createNgModule,
    ViewContainerRef,
} from "@angular/core";

import { ParagraphDeprecated } from "@hermes/api-model-editorial";
import { Logger } from "@hermes/logger";
import { LOGGER } from "@hermes/web-logger";

import {
    CHAPTERS_COMPONENT,
    CHAPTERS_PARAGRAPH,
    IS_FIRST_PARAGRAPH,
    SHOULD_PRELOAD_MEDIA,
} from "../../core";

import { StoryParagraphs } from "./story-paragraph.declaration";

@Directive({ selector: "[hStoryParagraph]" })
export class StoryParagraphDirective implements OnChanges {
    @Input()
    public hStoryParagraph!: ParagraphDeprecated;

    @Input()
    public hStoryParagraphShouldPreloadMedia = false;

    @Input()
    public hStoryParagraphIsFirst = false;

    constructor(
        @Inject(LOGGER) private logger: Logger,
        private injector: Injector,
        private containerReference: ViewContainerRef,
        private changeDetector: ChangeDetectorRef,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        this.containerReference.clear();

        if (changes.hStoryParagraph) {
            if (
                this.hStoryParagraph &&
                this.hStoryParagraph.type in StoryParagraphs
            ) {
                this.createParagraph();
            } else {
                this.logger.warn(
                    `Paragraph type doesn't exist, received : ${this.hStoryParagraph.type}`,
                );
            }
        }
    }

    private createParagraph(): Promise<void> {
        return StoryParagraphs[
            this.hStoryParagraph.type as keyof typeof StoryParagraphs
        ]()
            .then((module) => createNgModule(module, this.injector))
            .then((moduleReference) =>
                this.containerReference.createComponent(
                    moduleReference.injector.get(CHAPTERS_COMPONENT),
                    {
                        index: this.containerReference.length,
                        injector: Injector.create({
                            providers: [
                                {
                                    provide: CHAPTERS_PARAGRAPH,
                                    useValue: this.hStoryParagraph,
                                },
                                {
                                    provide: SHOULD_PRELOAD_MEDIA,
                                    useValue:
                                        this.hStoryParagraphShouldPreloadMedia,
                                },
                                {
                                    provide: IS_FIRST_PARAGRAPH,
                                    useValue: this.hStoryParagraphIsFirst,
                                },
                            ],
                            parent: this.injector,
                        }),
                        ngModuleRef: moduleReference,
                    },
                ),
            )
            .then(() => this.changeDetector.detectChanges())
            .catch((error) =>
                this.logger.error(
                    `Cannot instanciate component ${this.hStoryParagraph.type}, cause : ${error}`,
                ),
            );
    }
}
